import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=2c2fefae&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=2c2fefae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2fefae",
  null
  
)

export default component.exports